import * as React from "react";
import CardCustomizeLayoutModal from "./CardCustomizeLayoutModal";
import { CARD_PREFERENCE_TYPE, CARD_PREFERENCE_PAGE } from "../constants/cardPreferences";

interface DashboardCustomizeLayoutModalProps {
  open: boolean;
  onClose: () => void;
}

const DashboardCustomizeLayoutModal: React.FC<DashboardCustomizeLayoutModalProps> = ({
  open,
  onClose,
}) => {
  return (
    <CardCustomizeLayoutModal
      open={open}
      onClose={onClose}
      type={CARD_PREFERENCE_TYPE.ADMIN}
      page={CARD_PREFERENCE_PAGE.DASHBOARD}
    />
  );
};

export default DashboardCustomizeLayoutModal;

